export function getWorker(data) {
    let { getWorkerRequest, getWorkerError, getWorkerResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_worker',
        this.createBundle('get_worker', { id: data }, this.GET, getWorkerRequest, getWorkerResult, getWorkerError)
    )
}
